@import 'styles/variables';

.header {
  width: 100%;
  height: 140px;
  position: relative;
  display: flex;
  justify-content: center;
}

.coverImage {
  overflow: hidden;
  border-radius: 8px;
  width: 100%;
  height: 100%;
}

.profileImage {
  width: 120px;
  height: 120px;
  position: absolute;
  bottom: -30%;
  border-radius: 50%;
  overflow: hidden;
  border: 3px solid $white;
  font-size: 49px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-mask-image: radial-gradient(white, black);
}
